const DataTableColumnHeaderWrap = ({ title }: { title: string }) => {
    return (
        <div className="text-center break-words whitespace-normal">
            <span className="line-clamp-2">{title}</span>
        </div>
    );
};

export default DataTableColumnHeaderWrap;
